import React from 'react';
import { Route, Switch } from "react-router-dom";
import {SecurityProvider} from "../../context/security-context";
import SecurityDetails from "./security-details/security-details";
import SecurityList from "./security-list/security-list";

const Securities = () => {
  return (
    <Switch>
      <Route exact path="/securities">
        <SecurityList />
      </Route>
      <Route path="/securities/:securityId">
        <SecurityProvider>
          <SecurityDetails />
        </SecurityProvider>
      </Route>
    </Switch>
  )
}

export default Securities;
